import { gql } from "@apollo/client";

export const GET_LOGS_BY_ORGID = gql`
  query GetLogsByOrgId($orgId: Int) {
    getLogsByOrgId(orgId: $orgId) {
      Id
      tableName
      updatedAt
      orgId
    }
  }
`;
